export default {
    _queue : [],
    _length : 0,
    _timeout : null,
    dequeueUpdateTimeoutInMs : null,
    queueUpdateTimeoutInMs : null,
    dequeue(promise){
        this._queue = this._queue.filter((element)=>{
            return element !== promise;
        });
        this._updateLength(this.dequeueUpdateTimeoutInMs);
    },
    isLoaded(){
        return !this._length;
    },
    isLoading(){
        return !!this._length;
    },
    queue(promise){
        this._queue.push(promise);
        promise.then(()=>{
            this.dequeue(promise);
        });
        this._updateLength(this.queueUpdateTimeoutInMs);
        return promise;
    },
    _updateLength(timeoutInMs = null){
        window.clearTimeout(this._timeout);
        if (timeoutInMs === null) {
            this._length = this._queue.length;
            return;
        }
        this._timeout = window.setTimeout(()=>{
            this._length = this._queue.length;
        }, timeoutInMs);
    },
}
